import { createGtm } from '@gtm-support/vue-gtm'

export const gtm = (id: string) =>
  createGtm({
    id,
    enabled: import.meta.env.DEV || import.meta.env.MODE === 'stage', // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: import.meta.env.DEV, // Whether or not display console logs debugs (optional)
    loadScript: true
  })
